export const BASE_FARE = "Base Fare per day";
export const TAXES_AND_FEES = "Taxes & Fees";
export const TOTAL = "Total";
export const UNDERAGE_TEXT =
  "This rental car company may charge an underage driver fee at pick-up.";
export const UNDERAGE_DRIVER_AGE_MIN = 25;
